import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { PaymentMethod } from './PaymentMethod';
import React, { useEffect, useState } from 'react';
import { PAYMENT_METHODS } from 'src/constants/payments';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import { BackdropLoader } from '@livable/saas-react-components';
export const ReimbursementDetailsTab = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    propertiesPayoutMethods = _useState2[0],
    setPropertiesPayoutMethods = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    propertiesAddresses = _useState4[0],
    setPropertiesAddresses = _useState4[1];
  const fetchData = async () => {
    try {
      if (store.account.featureFlagsStore.getIsNewPayoutEnabled) {
        const propertyIds = {};
        const methodsResp = await store.payment.getCompanyPayoutMethodsAsync.run({});
        const addressesResp = await store.company.getCompanyPropertiesAsync.run();
        methodsResp.response.map(i => i.propertyIds.map(a => {
          var _addressesResp$respon;
          if (!(a in propertyIds)) propertyIds[a] = (_addressesResp$respon = addressesResp.response.find(e => e.propertyId === a)) === null || _addressesResp$respon === void 0 ? void 0 : _addressesResp$respon.address;
        }));
        setPropertiesPayoutMethods(methodsResp.response);
        setPropertiesAddresses(propertyIds);
      } else {
        const _await$Promise$all = await Promise.all([await store.payment.getCompanyAchDirectDepositsListAsync.run({}), await store.payment.getCompanyPayoutRegularChecksListAsync.run({}), await store.company.getCompanyPropertiesAsync.run()]),
          _await$Promise$all2 = _slicedToArray(_await$Promise$all, 3),
          getCompanyAchDirectDepositsListAsyncResp = _await$Promise$all2[0],
          getCompanyPayoutRegularChecksListAsyncResp = _await$Promise$all2[1],
          getCompanyPropertiesAsyncResp = _await$Promise$all2[2];
        if (getCompanyAchDirectDepositsListAsyncResp.isSuccessful && getCompanyPayoutRegularChecksListAsyncResp.isSuccessful && getCompanyPropertiesAsyncResp.isSuccessful) {
          const parcer = (previousValue, currentValue) => {
            const existingPropertyIndex = previousValue.findIndex(i => i.propertyId === currentValue.propertyId);
            if (existingPropertyIndex !== -1) {
              previousValue[existingPropertyIndex].payoutData.push(currentValue);
            } else {
              var _getCompanyProperties, _getCompanyProperties2;
              previousValue.push({
                propertyId: currentValue.propertyId,
                propertyAddress: (_getCompanyProperties = getCompanyPropertiesAsyncResp.response.find(property => property.propertyId === currentValue.propertyId)) === null || _getCompanyProperties === void 0 ? void 0 : _getCompanyProperties.propertyAddress,
                propertyStatus: (_getCompanyProperties2 = getCompanyPropertiesAsyncResp.response.find(property => property.propertyId === currentValue.propertyId)) === null || _getCompanyProperties2 === void 0 ? void 0 : _getCompanyProperties2.propertyStatus,
                payoutData: currentValue
              });
            }
            return previousValue;
          };
          const data = [...getCompanyAchDirectDepositsListAsyncResp.response.reduce(parcer, []).map(i => {
            return _objectSpread(_objectSpread({}, i), {}, {
              payoutData: {
                ["".concat(PAYMENT_METHODS.ACH)]: i.payoutData
              }
            });
          }), ...getCompanyPayoutRegularChecksListAsyncResp.response.reduce(parcer, []).map(i => {
            return _objectSpread(_objectSpread({}, i), {}, {
              payoutData: {
                ["".concat(PAYMENT_METHODS.RegularCheck)]: i.payoutData
              }
            });
          })].reduce((previousValue, currentValue) => {
            const existingPropertyIndex = previousValue.findIndex(i => i.propertyId === currentValue.propertyId);
            if (existingPropertyIndex !== -1) {
              previousValue[existingPropertyIndex].payoutData = _objectSpread(_objectSpread({}, previousValue[existingPropertyIndex].payoutData), currentValue.payoutData);
            } else {
              previousValue.push(currentValue);
            }
            return previousValue;
          }, []).filter(property => property.propertyStatus === PROPERTY_STATUS_ENUM.Active);
          setPropertiesPayoutMethods(data);
        }
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.getCompanyAchDirectDepositsListAsync.inProgress || store.payment.getCompanyPayoutRegularChecksListAsync.inProgress || store.payment.getCompanyPayoutMethodsAsync.inProgress || store.company.getCompanyPropertiesAsync.inProgress
  }), store.account.featureFlagsStore.getIsNewPayoutEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, propertiesPayoutMethods.map(property => /*#__PURE__*/React.createElement(PaymentMethod, {
    key: property.id,
    payoutData: property,
    triggerReload: fetchData,
    propertiesAddresses: propertiesAddresses
  }))), !store.account.featureFlagsStore.getIsNewPayoutEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, propertiesPayoutMethods.map(property => /*#__PURE__*/React.createElement(PaymentMethod, {
    key: property.propertyAddress + property.propertyId,
    propertyAddress: property.propertyAddress,
    propertyId: property.propertyId,
    payoutData: property.payoutData,
    triggerReload: fetchData
  }))));
});